<div class="file-brower-content-container">
    <table aria-describedby="">
        <tr class="row-header">
            <th class="column-1 header-1">Name</th>
            <th class="column-2">Date</th>
        </tr>
        <ng-container *ngFor="let data of flatTransformedData; let index = index;">
            <ng-container *ngIf="data.type==='folder'">
                <tr (click)="highlightCurrentSelection(index)" class="table-row"
                    [ngClass]="{'row-selected': data.isSelected == true}">
                    <td class="column-1" [ngStyle]='indentationOfNestedEle(index)'>
                        <div class="name-container">
                            <div class="carot-icon-container" *ngIf="data.type === 'folder' && !data.isTemporary">
                                <mat-icon (click)="toggleNestedData(index)">
                                    {{ data.isOpened ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}
                                  </mat-icon>
                            </div>
                            <div class="folder-name-container folder-icon">
                                <div [matTooltip]="data.name" class="ellipsis folder-name-padding"
                                    *ngIf="!data.isTemporary">{{data.name}}</div>
                                <div>
                                    <input *ngIf="data.isTemporary" type="text" [(ngModel)]="folderName"
                                        (ngModelChange)="validateFolderNameDuplicate()" placeholder="Untitled Folder">
                                    <mat-error class="error-text" *ngIf="data.isTemporary && folderName.length === 0">
                                        This field is required.
                                    </mat-error>
                                    <mat-error class="error-text"
                                        *ngIf="data.isTemporary && duplicateFolderNamePresent">
                                        Folder with this name already exists.
                                    </mat-error>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td class="column-2">
                        <span *ngIf="!data.isTemporary">-</span>
                        <div class="create-folder-btns" *ngIf="data.isTemporary">
                            <button class="inline-btn" (click)='createNewFolder(index)'><mat-icon
                                    [ngStyle]="{'color': data.isSelected ? 'white' : 'black'}">check</mat-icon></button>
                            <button class="inline-btn" (click)='cancelCreateNewFolder(index)'><mat-icon
                                    [ngStyle]="{'color': data.isSelected ? 'white' : 'black'}">close</mat-icon></button>
                        </div>
                    </td>
                </tr>
            </ng-container>
            <ng-container *ngIf="data.type==='file'">
                <tr (click)="openFile(index)" class="table-row"
                    [ngClass]="{'row-selected': data.isSelected == true, 'row-disabled': data.uploadFailed == true}"
                    (mouseenter)="onMouseHoverForDeleteAndEdit($event, data.currentPath, index)"
                    (mouseleave)="data.showIcon = false">
                    <td class="column-1" [ngStyle]='indentationOfNestedEle(index)'>
                        <div class="name-container">
                            <div class="file-icon ellipsis" [matTooltip]="data.name" *ngIf="!data.renamingFile"
                                [ngStyle]="{ 'opacity': data.uploadFailed || data.incompleteFile ? '50%' : '100%', 'width': '95%' }">
                                {{data.name}}
                            </div>
                            <div>
                                <input (click)="$event.stopPropagation()" *ngIf="data.renamingFile" type="text"
                                    [(ngModel)]="data['temporaryName']"
                                    (ngModelChange)="validateFileNameDuplicate(index)">
                                <mat-error [ngStyle]="{'color': data.isSelected ? 'white' : 'red'}"
                                    *ngIf="data.renamingFile && data.temporaryName.length == 0">
                                    This field is required.
                                </mat-error>
                                <mat-error [ngStyle]="{'color': data.isSelected ? 'white' : 'red'}"
                                    *ngIf="data.renamingFile && data.duplicateFileName">
                                    File with this name already exists.
                                </mat-error>
                            </div>
                            <div class="upload-fail-warning" *ngIf="data.uploadFailed">
                                <mat-icon matTooltip="Failed to upload file.">error_outline</mat-icon>
                            </div>
                            <div *ngIf="data.incompleteFile && !data.uploadFailed" class="upload-progress">
                                {{data.progress}}%</div>
                            <ng-container
                                *ngIf="!data.incompleteFile && data.canDeleteEdit && data.showIcon && !data.renamingFile">
                                <!-- Todo: add user permission manager to the files. -->
                                <!-- <kt-user-permission-manager [userList] = "userList" [selectedUserList] = "selectedUserList"></kt-user-permission-manager>
                                                            <div class="permision-btn" class="side-btn" (click) = "openPermissionManager($event, index)"><mat-icon class="side-icon">group</mat-icon></div> -->
                                <div class="side-btn" (click)="editName($event, data.currentPath, index)"
                                    matTooltip="Edit"><mat-icon class="side-icon">edit</mat-icon></div>&nbsp;
                                <div class="side-btn" (click)="deleteFile($event, data.currentPath, index)"
                                    matTooltip="Delete"><mat-icon class="side-icon"
                                        [ngStyle]="{'color': data.isSelected ? 'white' : 'red'}">delete_outline</mat-icon>
                                </div>
                            </ng-container>
                        </div>
                    </td>
                    <td class="column-2" *ngIf="data.renamingFile">
                        <div class="create-folder-btns">
                            <button ngClass="inline-btn" (click)='renameFile($event, index)'><mat-icon
                                    [ngStyle]="{'color': data.isSelected ? 'white' : 'black'}">check</mat-icon></button>
                            <button class="inline-btn" (click)='cancelRename($event, index)'><mat-icon
                                    [ngStyle]="{'color': data.isSelected ? 'white' : 'black'}">close</mat-icon></button>
                        </div>
                    </td>
                    <td class="column-2" *ngIf="!data.renamingFile">
                        {{data.lastModified | date:'dd MMM y, hh:mm a'}}
                    </td>
                </tr>
            </ng-container>
        </ng-container>
    </table>
</div>